
import { useState } from 'react';
import emailjs from '@emailjs/browser';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import './contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', location: '', message: '' });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Sending data:", formData);
    emailjs.send(
      'service_dzot98i',
      'template_eewd8mm',
      {
        name:     formData.name,
        email:    formData.email,
        phone:    formData.phone,
        location: formData.location,
        message:  formData.message,
      },
      'hUq75JWL_H73HBNXu'
    ).then(
      (result) => {
        console.log("✅ Success:", result.text);
        alert("Message sent successfully!");
        setFormData({ name: '', email: '', phone: '', location: '', message: '' });

        if (window.gtag) {
          window.gtag('event', 'form_submission', {
            event_category: 'Contact',
            event_label: 'Contact Form',
            value: 1
          });
        }
      },
      (error) => {
        console.error("❌ EmailJS Error:", error);
        alert("Couldn't send message. Error occurred.");
      }
    );
  };

  return (
    <section className="contact section-padding" id="contact">
      <div className="container">
        <div className="section-title">
          <span className="title" data-aos="fade-up" data-aos-duration="600">contact us</span>
          <h2 className="sub-title" data-aos="fade-up" data-aos-duration="600">have any question ?</h2>
        </div>
        
        {/* Google Maps Embed - Full Width on Top */}
        <div className="google-map-wrapper" data-aos="fade-up" data-aos-duration="600">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3148.3272045572744!2d144.7393624!3d-37.899414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad689f8c59bec43%3A0x27313f2e1d8c3f51!2sNik%E2%80%99s%20Cleaning!5e0!3m2!1sen!2sus!4v1772232965855!5m2!1sen!2sus" 
            width="100%" 
            height="450" 
            style={{border: 0}} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Nik's Cleaning Location Map"
          ></iframe>
        </div>

        {/* Contact Info and Form Grid */}
        <div className="grid contact-grid">
          <div className="contact-info">
            <div className="contact-info-item" data-aos="fade-up" data-aos-duration="600">
              <LocationOnIcon />
              <h3>Address</h3>
              <p>47 tribeca drive, Point Cook, Victoria 3030</p>
            </div>
            <div className="contact-info-item" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
              <CallIcon />
              <h3>Call us</h3>
              <p><a href="tel:+61493519401" style={{color: 'inherit', textDecoration: 'none'}}>+61 493 519 401</a></p>
            </div>
            <div className="contact-info-item" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
              <MailOutlineIcon />
              <h3>Email us</h3>
              <p><a href="mailto:nikselitecleaning.vic@gmail.com" style={{color: 'inherit', textDecoration: 'none'}}>nikselitecleaning.vic@gmail.com</a></p>
            </div>
          </div>

          <div className="contact-form" data-aos="fade-up" data-aos-duration="600" data-aos-delay="300">
            <form onSubmit={handleSubmit}>
              <div className="input-box">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  className="input-control"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="input-box">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="input-control"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="input-box">
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone"
                  className="input-control"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="input-box">
                <input
                  type="text"
                  name="location"
                  placeholder="Full Property Address"
                  className="input-control"
                  required
                  value={formData.location}
                  onChange={handleChange}
                />
              </div>
              <div className="input-box">
                <textarea
                  name="message"
                  placeholder="Message"
                  className="input-control"
                  required
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="btn-wrap">
                <button type="submit" className="btn">Send Message</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
